


























import {useGtm, useNews} from '~/composables';
import { groupBy, size, isEmpty, concat, split, find, trimStart, startsWith} from 'lodash-es';
import {
  defineComponent,
  onMounted,
  ref,
  useRouter,
} from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'NewsList',
  components: {
  },

  setup() {
    const {
      getNewsTypes,
      getNewsList,
    } = useNews();
    const route = useRouter();
    const currentUrl = trimStart(route.currentRoute.path, '/');
    const { eventCustomlinksInteracted } = useGtm();
    const newsListLength = ref(0);
    const newsListArray = ref({});
    const newsData = ref([]);
    const currentPage = ref(1);
    const totalPage = ref(1);
    const typeId = ref(null);
    const pageSize = ref(20);
    const dir = ref(null);
    const groupedByDate = function(data){
      return Object.entries(groupBy(data, 'date'));
    };

    const loadNewsType = async() => {
        const data = await getNewsTypes();
        return data['getNewsTypes'];
    };
    onMounted(async () => {
      const newsType = await loadNewsType();
      const type = find(newsType, function(type){
        return type.url == currentUrl;
      }) ?? '';
      typeId.value = type && type.id;
      dir.value = type.dir;
      const newsList = await loadNewsList(typeId.value, pageSize.value, currentPage.value, dir.value);
      totalPage.value = newsList.total_pages;
      newsData.value = newsList.data;
      if (newsList.data.length > 0) {
        newsListArray.value = groupedByDate(newsList.data);
      }
      newsListLength.value = size(newsListArray.value);
    });
    const loadNewsList = async (typeId, pageSize, currentPage, dir) => {
      const newsParams = typeId ? {
        "type_id": typeId,
        "page_size": pageSize,
        "page_id": currentPage,
        "dir": dir
      } : {
        "page_size": pageSize,
        "page_id": currentPage,
        "dir": dir
      };
      const data = await getNewsList(newsParams);
      return data['getNews'];
    };
    const handleGtmEvent = function(label) {
      eventCustomlinksInteracted({
          "eventlabel": label,
          "eventCategory": "Cms Page Button Links",
        });
    };
      const loadMoreNews = async (label) => {
        if (currentPage.value < totalPage.value) {
          currentPage.value++;
          const data = await loadNewsList(typeId.value, pageSize.value - 5, currentPage.value, dir.value);
          newsData.value = concat(newsData.value, data.data);
          if (!isEmpty(data)) {
            newsListArray.value = groupedByDate(newsData.value);
          }
        }
        handleGtmEvent(label);
      };
    return {
      newsListArray,
      groupedByDate,
      newsListLength,
      currentPage,
      totalPage,
      newsData,
      loadMoreNews,
      loadNewsList,
      loadNewsType,
      split,
      handleGtmEvent,
      startsWith,
      httpText: 'https://'
    };
  }
});

